const messages = {
  foundingYear: 'bankDetails.additionalDetails.foundingYear',
  foundingPlace: 'bankDetails.additionalDetails.foundingPlace',
  employeeCount: 'bankDetails.additionalDetails.employeeCount',
  branchCount: 'bankDetails.additionalDetails.branchCount',
  majorServices: 'bankDetails.additionalDetails.majorService',
  distributionFocus: 'bankDetails.additionalDetails.distributionFocus',
  branchMarkets: 'bankDetails.additionalDetails.branchMarkets',
  totalCapitalRatio: 'bankDetails.additionalDetails.totalCapitalRatio',
  minRequiredTotalCapitalRatio: 'bankDetails.additionalDetails.minRequiredTotalCapitalRatio',
  mostRecentROE: 'bankDetails.additionalDetails.mostRecentROE',
  avg3YearROE: 'bankDetails.additionalDetails.avg3YearROE',
  listed: 'bankDetails.additionalDetails.listed',
  isListed: 'bankDetails.additionalDetails.isListed',
  isNotListed: 'bankDetails.additionalDetails.isNotListed',
  marketCap: 'bankDetails.additionalDetails.marketCap',
  marketCapInMillions: 'bankDetails.additionalDetails.marketCapInMillions',
  bankRating: 'bankDetails.additionalDetails.bankRating',
  parentRating: 'bankDetails.additionalDetails.parentRating',
  parentCompanyShares: 'bankDetails.additionalDetails.parentCompanyShares',
  dgsCountry: 'bankDetails.additionalDetails.dgsCountry',
  dgsAmount: 'bankDetails.additionalDetails.dgsAmount',
  countryRating: 'bankDetails.additionalDetails.countryRating',
  footnote: 'bankDetails.additionalDetails.footnote',
  showMore: 'bankDetails.additionalDetails.showMore',
  showLess: 'bankDetails.additionalDetails.showLess',
};

export default messages;
